import "./Footer.pcss";

import AbstractView from "../AbstractView.js";

export default class FooterView extends AbstractView {}
